import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { GlobalStyle, Sidebar, DashboardBody } from "./style";
import ResponsiveFix from "../../components/responsiveFix";
import { Header } from "../components/header";
import * as types from "../../actions/actionTypes";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import { Confirm } from "../../components/confirm";
import { FullScreenLoading } from "../../components/loading";
import { Add } from "./components/add/add";

class Index extends Component {
  constructor(props) {
    super(props);
    let sidebarExpand = window.innerWidth > 1199;
    if (localStorage.getItem("expand") !== null) {
      sidebarExpand = localStorage.getItem("expand") === "true";
    }
    this.state = {
      hasShadow: false,
      sidebarExpand: sidebarExpand,
      userClickTrigger: false,
      showConfirm: false
    };
    this.onScroll = this.onScroll.bind(this);
    this.sidebarToggleHandler = this.sidebarToggleHandler.bind(this);
    this.windowResizeHandler = this.windowResizeHandler.bind(this);
    this.checkActive = this.checkActive.bind(this);
  }
  componentDidMount() {
    window.addEventListener("resize", this.windowResizeHandler);
    sessionStorage.removeItem("activityEmployeeContact");
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.windowResizeHandler);
  }
  onScroll(event) {
    if (event.target.scrollTop >= 10) {
      this.setState({ hasShadow: true });
    } else {
      this.setState({ hasShadow: false });
    }
  }
  windowResizeHandler() {
    this.setState({ sidebarExpand: window.innerWidth > 1199 });
    localStorage.setItem("expand", window.innerWidth > 1199);
  }
  sidebarToggleHandler() {
    if (!this.state.userClickTrigger) {
      window.removeEventListener("resize", this.windowResizeHandler);
    }
    this.setState({
      sidebarExpand: !this.state.sidebarExpand,
      userClickTrigger: true
    });
    localStorage.setItem("expand", !this.state.sidebarExpand);
  }
  checkActive(match, location) {
    if(!location) return false;
    const {pathname} = location;
    return (pathname === "/accountreview" || pathname === "/account-review" || pathname === "/cash-flow");
  }
  render() {
    const { Component, route, headerData } = this.props;
    const { hasShadow, sidebarExpand, showConfirm } = this.state;
    return (
      <ResponsiveFix>
        <Confirm
          show={showConfirm}
          rejectHandler={() => this.setState({ showConfirm: false })}
          close={() => this.setState({ showConfirm: false })}
          content={{
            type: "info",
            title: "توجه!",
            message: "این امکان در ورژن بعدی مپسا ارائه خواهد شد.",
            rejectButtonText: "باشه",
            icon: "icon mapsa-info"
          }}
        />
        <GlobalStyle />
        <Header
          sidebarToggleHandler={this.sidebarToggleHandler}
          data={headerData}
          getInit={this.props.requestInit}
        >
          <Add hasShadow={hasShadow} expand={sidebarExpand} />
        </Header>
        <Sidebar expand={sidebarExpand} onScroll={this.onScroll}>
          <ul className="sidebar-list">
            <NavLink
              to="/"
              className={
                this.props.history.location.pathname === "/"
                  ? "list-item-active"
                  : ""
              }
              title="خانه"
            >
              <li>
                <i className="icon mapsa-home" />
                <span className="list-item-text">خانه</span>
                {/*<div className="sidebar-badge">*/}
                {/*<span>2</span>*/}
                {/*</div>*/}
              </li>
            </NavLink>
            <NavLink
              to="/accountreview"
              activeClassName="list-item-active"
              title="مرور حساب‌ها"
              isActive={this.checkActive}
            >
              <li>
                <i className="icon mapsa-growth" />
                <span className="list-item-text">مرور حساب‌ها</span>
                {/*<div className="sidebar-badge">*/}
                {/*<span>5</span>*/}
                {/*</div>*/}
              </li>
            </NavLink>
            {/*<NavLink to={'/dashboard'}>*/}
            {/*<li>*/}
            {/*<i className="icon mapsa-cheque"/>*/}
            {/*<span className="list-item-text">گزارش جامع</span>*/}
            {/*<div className="sidebar-badge">*/}
            {/*<span>8</span>*/}
            {/*</div>*/}
            {/*</li>*/}
            {/*</NavLink>*/}
            <NavLink
              to="/balance-sheet"
              activeClassName="list-item-active"
              title="گزارش مانده حساب‌ها"
            >
              <li>
                <i className="icon mapsa-analytics"> </i>
                <span className="list-item-text">گزارش مانده حساب‌ها</span>
              </li>
            </NavLink>
            <NavLink
                to="/overall-cost"
                activeClassName="list-item-active"
                title="قیمت تمام‌شده"
            >
              <li>
                <i className="icon mapsa-business-and-finance-1"> </i>
                <span className="list-item-text">قیمت تمام‌شده</span>
              </li>
            </NavLink>
            <NavLink
                to="/cheque-review"
                activeClassName="list-item-active"
                title="مرور چک‌ها"
            >
              <li>
                <i className="icon mapsa-cheque" />
                <span className="list-item-text">مرور چک‌ها</span>
                {/*<div className="sidebar-badge">*/}
                {/*<span>5</span>*/}
                {/*</div>*/}
              </li>
            </NavLink>
            {JSON.parse(localStorage.getItem('use_imprest')) &&
            <NavLink to={"/pettycash_report"}>
              <li>
                <i className="icon mapsa-cash" />
                <span className="list-item-text">گزارش تنخواه</span>
              </li>
            </NavLink>
            }
            <NavLink
                to="/cost-profit"
                activeClassName="list-item-active"
                title="گزارش سود و زیان"
            >
              <li>
                <i className="icon mapsa-profit-loss"> </i>
                <span className="list-item-text">گزارش سود و زیان</span>
              </li>
            </NavLink>
          </ul>
          <div className="sidebar-footer">
            <div>
              <NavLink
                title="راهنمای مپسا"
                to="//mapsa.ir/help"
                target="_blank"
              >
                راهنما
              </NavLink>{" "}
              <span className="circle-separator" />
              <NavLink
                title=" قوانین و مقررات"
                to="//mapsa.ir/terms/"
                target="_blank"
              >
                قوانین و مقررات
              </NavLink>
            </div>
            <div className="copyright">
              حقوق این وبسایت متعلق به مپسا میباشد.
            </div>
            <div className="minimum-mode-icon">
              <NavLink
                to="//mapsa.ir/help"
                target="_blank"
                title="راهنمای مپسا"
              >
                <i className="icon mapsa-i-letter" />
              </NavLink>
            </div>
          </div>
        </Sidebar>
        <DashboardBody expand={sidebarExpand}>
          <div className="dashboard-container">
            <Suspense fallback={<FullScreenLoading />}>
              <Component route={route} expand={sidebarExpand} />
            </Suspense>
          </div>
        </DashboardBody>
      </ResponsiveFix>
    );
  }
}

const mapStateToProps = state => {
  return {
    headerData: state.Init.data.data || []
  };
};

const mapDispatchToProps = dispatch => {
  return {
    requestInit: () => {
      dispatch({ type: types.INIT_REQUEST });
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Index)
);